<template>
  <section>
    <div v-if="loading">

      <div class="grid grid-cols-12 mt-8">
          <div class="col-span-6 lg:col-span-6 xxl:col-span-6">
            <h2 class="intro-y text-lg font-medium mr-auto mt-2">
              Mis Notas ({{ notes.length }})
            </h2>
          </div>
          <div class="col-span-6 sm:w-auto flex justify-end">
              <a data-target="#note" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Agregar Nota</a>
          </div>
      </div>

      <!-- Edit -->
          <div class="intro-y box mt-6" v-if="boxedit">
            <div
              class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
            >
              <h2 class="font-medium text-base mr-auto">Editar Nota</h2>
            </div>
            <form @submit.prevent="updateNote">
              <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
                <div class="col-span-6 sm:col-span-6">
                  <label>Titulo:</label>
                  <input
                    v-on:input="updateValue('title', $event)"
                    type="text"
                    class="input w-full border mt-2 flex-1"
                    :value="note.title"
                    required
                  />
                </div>
                <div class="col-span-6 sm:col-span-6">
                  <label>Descripción:</label>
                  <textarea
                    v-on:input="updateValue('description', $event)"
                    type="email"
                    class="input w-full border mt-2 flex-1"
                    :value="note.description"
                    required
                  ></textarea>
                </div>
              </div>
              <div class="px-5 py-3 text-right border-t border-gray-200">
                <button
                  type="button"
                  v-on:click="closeEditNote()"
                  class="button w-20 border text-gray-700 mr-1"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  class="button w-20 bg-theme-1 text-white"
                  id="update"
                >
                  Modificar
                </button>
              </div>
            </form>
          </div>
        <!-- END: Edit -->

      <!-- List -->
      <div class="intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5">
        <div class="intro-y col-span-12 sm:col-span-12 md:col-span-6 xxl:col-span-6" v-for="note in notes">
            <div class="file box rounded-md px-5 pt-5 pb-5 px-3 sm:px-5 relative zoom-in">
                <div class="text-gray-900 font-bold">{{note.title}}</div>
                <div class="text-gray-600 text-xs text-wrap mt-2"><pre>{{note.description}}</pre></div>
                <div class="absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto">
                    <a class="dropdown-toggle w-5 h-5 block" href="javascript:;">
                      <app-icon v-bind:name="'more-vertical'" v-bind:classname="'w-5 h-5 text-gray-500'"></app-icon>
                    </a>
                    <div class="dropdown-box mt-5 absolute w-40 top-0 right-0 z-10">
                        <div class="dropdown-box__content box p-2">
                            <a v-on:click="editNote(note)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                              <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon>
                              Editar
                            </a>
                            <a v-on:click="removeNote(note)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                              <app-icon v-bind:name="'trash'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon> Eliminar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <!-- END: List -->

      </div>

      <app-loading v-else />

      <!-- Modal -->
      <div class="modal" id="note">
        <div class="modal__content modal__content--sm">
          <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
            <h2 class="font-medium text-base mr-auto">
                Agregar Nota
            </h2>
          </div>
          <form  @submit.prevent="createNote">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
                <label>Titulo</label>
                <input type="text" class="input w-full border mt-2 flex-1" v-model="note.title" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Descripción</label>
                <textarea type="text" class="input w-full border mt-2 flex-1" v-model="note.description" required></textarea>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
              <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
          </form>
        </div>
      </div>
      <!-- Modal End -->

  </section>
</template>

<script>
import { mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'ListNotes',
  data () {
    return {
      loading: false,
      boxedit: false,
      note: this.defineNote(),
      notes: null,
      note_current: {}
    }
  },
  beforeMount () {
   this.getNotes()
  },
  methods: {
    async getNotes () {
      this.loading = false
      try {
        const { list } = await this.get(
          `/note`
        )
        this.notes = list
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    defineNote() {
      return {
        title: '',
        description: '',
        entity: 'note'
      }
    },
    createNote () {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.post(vm.note).then(item => {
        window.$('#note').modal('hide')
        vm.defineNote()
        vm.loading = true
        window.$('#create').button('reset')
        window.location.reload()
      })
      .catch(error => {
        window.$('#create').button('reset')
        vm.defineNote()
        vm.loading = true
      })
    },
    editNote: function (value) {
      this.boxedit = true
      this.note = value
    },
    closeEditNote: function () {
      this.boxedit = false
      this.note_current = {}
    },
    updateValue(attribute, e) {
      this.note_current[attribute] = e.target.value
    },
    updateNote() {
      var vm = this
      vm.loading = false
      window.$('#create').button('loading')
      vm.note_current.id = vm.note.id
      vm.note_current.entity = 'note'
      console.log(vm.note_current)
      vm.put(vm.note_current).then(item => {
        window.$('#note').modal('hide')
        vm.defineNote()
        vm.loading = true
        window.$('#create').button('reset')
        window.location.reload()
      })
        .catch(error => {
          window.$('#create').button('reset')
          vm.defineNote()
          vm.loading = true
        })
    },
    removeNote: function (value) {
      var vm = this
      vm.form = {
        id : value.id,
        entity : 'note'
      }
      vm.deleteItem(vm.form).then(item => {
        vm.loading = true
        window.location.reload()
      })
      .catch(message => {
        vm.loading = true
      })
    },
    ...mapActions([
      'get',
      'post',
      'put',
      'deleteItem'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// ListNotes.vue?270a8905